import angular from 'angular';

angular.module('app.link_request').constant(
    'LINK_REQUEST',
    Object.freeze({
        TYPE:
            {
                client: 'BUYER',
                fournisseur: 'SELLER',
            },
    })
);
